export const CURRENCY_SYMBOLS:any = {
  'USD': '$',
};